import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteGetNextDocumentNumberAtom = createMutationAtomFactory(
  'brokerage.quoteGetNextDocumentNumber',
  () => ({
    tradeQuoteNextDocumentNumber: true,
  }),
);
